// Phase 1A Phase 9C.8c — Vault currency formatter.
//
// Pure helper. NO React, NO Supabase, NO browser APIs, NO clock
// reads, NO side effects. The Vault uses this single helper to
// render every Phantom-simulated cedi value so the visual format
// matches /home and the new Three-Pool panel.
//
// Truth contract:
//   - `null` / `undefined` / non-finite (NaN, ±Infinity) → "GH₵—".
//     The em-dash is the canonical "no ledger row yet" placeholder.
//     Never coerce these to "GH₵0".
//   - A real numeric `0` returns "GH₵0". 0 is a real number; only
//     missing values collapse to the em-dash.
//   - All other finite numbers: `GH₵${n.toLocaleString()}`.
//
// The formatter is currency-only. Percentages and odds are NOT
// reformatted by this helper.

export function formatVaultCedis(value: number | null | undefined): string {
  if (value === null || value === undefined) return "GH₵—";
  if (!Number.isFinite(value)) return "GH₵—";
  return `GH₵${value.toLocaleString()}`;
}
